import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from "./ui/dropdown-menu";
import { Button } from "./ui/button";
import { MoreVertical } from "lucide-react";
import { cn } from "../lib/utils";

export default function DropDownButton({
  items,
  text = "",
  dropdownMenuTriggerBody = "",
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {dropdownMenuTriggerBody ? (
          dropdownMenuTriggerBody
        ) : (
          <Button className="px-2">
            {text ? text : <MoreVertical className="h-4 w-4" />}
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {items.map((item, index) => {
          if (item?.items) {
            // Nested dropdown
            return (
              <DropdownMenuSub key={index}>
                <DropdownMenuSubTrigger
                  className={cn(
                    "flex justify-between w-full",
                    item.className,
                    item.danger && "text-red-600 focus:text-red-600"
                  )}
                  disabled={item.disabled}
                >
                  {item.label}
                </DropdownMenuSubTrigger>
                <DropdownMenuSubContent>
                  {item.items.map((subItem, subIndex) => (
                    <DropdownMenuItem
                      key={subIndex}
                      onClick={subItem.onClick}
                      disabled={subItem.disabled}
                      className={cn(
                        subItem.className,
                        subItem.danger && "text-red-600 focus:text-red-600"
                      )}
                    >
                      {subItem.label}
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuSubContent>
              </DropdownMenuSub>
            );
          }

          return (
            <DropdownMenuItem
              key={index}
              onClick={item.onClick}
              className={cn(
                item.className,
                item.danger && "text-red-600 focus:text-red-600"
              )}
              disabled={item?.disabled}
            >
              {item.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
